import List from "./List";
import Create from "./Create";
import Edit from "./Edit";

export const CategoryCreate = Create;
export const CategoryList = List;
export const CategoryEdit = Edit;
